<template>
  <div id="app">
    <!-- ✅ 添加 router-view -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  max-width: 750px;
  margin: 0 auto;
  height: 100%;
  width: 100%;
}
html, body {
  height: 100%;
  width: 100%;
}
</style>
